import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

import CloudinaryImage from '../../../../cloudinary-media/image'
import {RESIZE_FULL_MOBILE_ONE_FOURTH_DESKTOP} from '../../../../../constants'

const CategoryTallImage = ({desktopImage, mobileImage, imageAlt, aspectRatio}) => {
    const mobileSrc = mobileImage || desktopImage

    return (
        <>
            <Box
                display={{base: 'none', md: 'block'}}
                height="100%"
                className="category-tall-image"
            >
                <CloudinaryImage
                    src={desktopImage}
                    alt={imageAlt}
                    aspectRatio={aspectRatio}
                    imgSizes={{md: '25vw', base: '100vw'}}
                    sizes={RESIZE_FULL_MOBILE_ONE_FOURTH_DESKTOP}
                    styles={{
                        aspectRatio: aspectRatio?.replace(':', ' / '),
                        width: '100%',
                        height: 'auto',
                        htmlWidth: aspectRatio?.split(':')[0],
                        htmlHeight: aspectRatio?.split(':')[1]
                    }}
                />
            </Box>
            <Box display={{base: 'block', md: 'none'}} className="category-tall-image">
                <CloudinaryImage
                    src={mobileSrc}
                    aspectRatio="389:438"
                    imgSizes={{base: '100vw'}}
                    sizes={[375, 390, 414, 768]}
                    alt={imageAlt}
                    styles={{
                        aspectRatio: '389/438',
                        width: '100%',
                        height: 'auto',
                        htmlWidth: 389,
                        htmlHeight: 438
                    }}
                />
            </Box>
        </>
    )
}

CategoryTallImage.propTypes = {
    desktopImage: PropTypes.string.isRequired,
    mobileImage: PropTypes.string,
    aspectRatio: PropTypes.string,
    imageAlt: PropTypes.string
}

export default CategoryTallImage
